
import { HealthLog } from './types';

export const THAI_LABELS = {
  APP_NAME: 'DPAC Digital Health',
  WEIGHT: 'น้ำหนัก (กก.)',
  HEIGHT: 'ส่วนสูง (ซม.)',
  BMI: 'ค่า BMI',
  BP: 'ความดันโลหิต (mmHg)',
  SYS: 'ความดันตัวบน (SYS)',
  DIA: 'ความดันตัวล่าง (DIA)',
  TG: 'ไตรกลีเซอไรด์',
  CHOL: 'คอเลสเตอรอล',
  HDL: 'HDL (ไขมันดี)',
  LDL: 'LDL (ไขมันเลว)',
  FBS: 'น้ำตาลในเลือด (FBS)',
  AST: 'ค่าตับ (AST)',
  ALT: 'ค่าตับ (ALT)',
  DISCIPLINE: 'คะแนนความวินัย (0-100)',
  PREDICT: 'ทำนายสุขภาพใน 3 เดือน',
  HISTORY: 'ประวัติสุขภาพ',
  ADD_LOG: 'บันทึกข้อมูลใหม่',
  REMINDERS: 'การแจ้งเตือนยา',
  ADVICE: 'คำแนะนำจาก AI'
};

export const MOCK_HEALTH_LOGS: HealthLog[] = [
  { id: '1', date: '2023-10-01', weight: 82, height: 175, bmi: 26.8, systolic: 145, diastolic: 95, triglyceride: 160, cholesterol: 240, hdl: 40, ldl: 168, fbs: 110, ast: 25, alt: 30 },
  { id: '2', date: '2023-11-01', weight: 81, height: 175, bmi: 26.4, systolic: 142, diastolic: 92, triglyceride: 155, cholesterol: 235, hdl: 42, ldl: 162, fbs: 105, ast: 24, alt: 28 },
  { id: '3', date: '2023-12-01', weight: 79, height: 175, bmi: 25.8, systolic: 138, diastolic: 88, triglyceride: 152, cholesterol: 228, hdl: 44, ldl: 154, fbs: 100, ast: 22, alt: 25 },
  { id: '4', date: '2024-01-01', weight: 78, height: 175, bmi: 25.5, systolic: 130, diastolic: 85, triglyceride: 148, cholesterol: 220, hdl: 45, ldl: 145, fbs: 98, ast: 20, alt: 22 }
];

export const MOCK_DATA = MOCK_HEALTH_LOGS.map(log => ({
  date: log.date,
  weight: log.weight,
  systolic: log.systolic,
  diastolic: log.diastolic,
  ldl: log.ldl
}));
